import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { api } from '../api/client.js';

const AuthContext = createContext(null);
const parseStoredUser = () => {
  try { return JSON.parse(localStorage.getItem('garmenterp_user') || sessionStorage.getItem('garmenterp_user')); }
  catch { return null; }
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(parseStoredUser);

  const persist = useCallback((data, remember = true) => {
    const storage = remember ? localStorage : sessionStorage;
    const other = remember ? sessionStorage : localStorage;
    storage.setItem('garmenterp_token', data.token);
    storage.setItem('garmenterp_user', JSON.stringify(data.user));
    other.removeItem('garmenterp_token');
    other.removeItem('garmenterp_user');
    setUser(data.user);
  }, []);

  const login = useCallback(async (credentials) => {
    const { data } = await api.post('/auth/login', credentials, { skipErrorToast: true });
    persist(data, credentials.remember);
  }, [persist]);

  const rfidLogin = useCallback(async (rfid) => {
    const { data } = await api.post('/auth/rfid', { rfid }, { skipErrorToast: true });
    if (data.token) persist({ token: data.token, user: {
      id: data.employee.employeeId, name: data.employee.name, role: data.role,
      employeeId: data.employee.employeeId, photoPath: data.employee.photoPath
    } }, false);
    return data;
  }, [persist]);

  const logout = useCallback(() => {
    ['garmenterp_token', 'garmenterp_user'].forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
    setUser(null);
  }, []);

  useEffect(() => {
    window.addEventListener('garmenterp:unauthorized', logout);
    return () => window.removeEventListener('garmenterp:unauthorized', logout);
  }, [logout]);

  const value = useMemo(() => ({ user, login, rfidLogin, logout }), [user, login, rfidLogin, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
